import { MAPPING_TERM_PATH } from './consts';

const customizedType = (t, type, terminologies) => {
  const translation = t(type, { defaultValue: undefined });
  if (translation === undefined) return translation;

  return (
    terminologies?.find((item) => item.key === MAPPING_TERM_PATH[type])
      ?.displayName || t(type.toUpperCase())
  );
};
export { customizedType };
